module.exports = __webpack_public_path__ + "media/images/pages/careers-support/benchmark_8-d7b65a578ae34c0cfb398ee7439c2a3a.svg";